// extracted by mini-css-extract-plugin
export default {"container":"_5aKNbw","title":"_1zvIy4","timeContainer":"zFujAs","timeValue":"_1KPNbQ","timeLabel":"_2V8HlM","timeSecond":"pprZ1H"};